import * as storeTypes from "./ovp.store-types";
import axios from "axios";
import { OvpJobCondition } from "./models/ovp-job-condition.models";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isActiveRequest: false,
        isTemplate: false,
        ovpJobConditions: [],
        globalOvpJobConditions: [],
        selectedUsers: {},
        currentOvpJobCondition: new OvpJobCondition()
    },
    mutations: {
        [storeTypes.SET_OVP_JOB_CONDITIONS]: (state, ovpJobConditions) =>
            (state.ovpJobConditions = ovpJobConditions),
        [storeTypes.SET_GLOBAL_OVP_JOB_CONDITIONS]: (state, ovpJobConditions) =>
            (state.globalOvpJobConditions = ovpJobConditions),
        [storeTypes.SET_CURRENT_OVP_JOB_CONDITIONS]: (
            state,
            currentOvpJobCondition
        ) => (state.currentOvpJobCondition = currentOvpJobCondition),
        [storeTypes.SET_IS_LOADING]: (state, isLoading) =>
            (state.isLoading = isLoading),
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActiveRequest) =>
            (state.isActiveRequest = isActiveRequest),
        [storeTypes.SET_SELECTED_OVP_USERS]: (state, {userId, userData}) =>
            (state.selectedUsers[userId] = userData),
        [storeTypes.UNSET_SELECTED_OVP_USERS]: (state, userId) =>
            (delete state.selectedUsers[userId])
    },
    actions: {
        async [storeTypes.ACTION_GET_OVP_JOB_CONDITIONS](
            store,
            { name = "", companyId = "" }
        ) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        let url = `/api/ovp?name=${name}`;

                        if (companyId.length) {
                            url = `/api/companies/${companyId}/ovp?name=${name}`;
                        }

                        const {
                            data: { success, error, ovpJobConditions }
                        } = await axios.get(url);

                        if (!success) {
                            return reject(error);
                        }



                        store.commit(
                            storeTypes.SET_OVP_JOB_CONDITIONS,
                            ovpJobConditions.map(ovpJobCondition =>
                                OvpJobCondition.fromArray(ovpJobCondition)
                            )
                        );
                        resolve(store.state.ovpJobConditions);
                    } catch ({
                        response: {
                            data: { error }
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_GET_GLOBAL_OVP_JOB_CONDITIONS](
            store,
            { name = "" }
        ) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        let url = `/api/ovp?name=${name}`;

                        const {
                            data: { success, error, ovpJobConditions }
                        } = await axios.get(url);

                        if (!success) {
                            return reject(error);
                        }

                        store.commit(
                            storeTypes.SET_GLOBAL_OVP_JOB_CONDITIONS,
                            ovpJobConditions.map(ovpJobCondition =>
                                OvpJobCondition.fromArray(ovpJobCondition)
                            )
                        );
                        resolve();
                    } catch ({
                        response: {
                            data: { error }
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_CREATE_OVP_JOB_CONDITION](
            store,
            { ovpJobCondition, companyId = "" }
        ) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        let url = "/api/ovp";

                        if (companyId.length) {
                            url = `/api/companies/${companyId}/ovp`;
                        }

                        const {
                            data: { success }
                        } = await axios.post(url, { ovpJobCondition });

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: { error }
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_OVP_JOB_CONDITION](
            store,
            { ovpJobCondition, companyId = "" }
        ) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        let url = `/api/ovp/${ovpJobCondition._id}`;

                        if (companyId.length) {
                            url = `/api/companies/${companyId}/ovp/${ovpJobCondition._id}`;
                        }

                        const {
                            data: { success }
                        } = await axios.put(url, {
                            ovpJobCondition
                        });

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: { error }
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        //For now only used to remove CompanyOvpJobCondition
        async [storeTypes.ACTION_REMOVE_OVP_JOB_CONDITION](
            store,
            { ovpJobConditionId, companyId = "" }
        ) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        if (!companyId.length) {
                            return reject('Nav kompānijas!');
                        }

                        const {
                            data: { success }
                        } = await axios.delete(`/api/companies/${companyId}/ovp/${ovpJobConditionId}`);

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: { error }
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_GENERATE_OVP_FORMS](
            store,
            { selectedUsers, companyId = "" }
        ) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data}  = await axios.post(`/api/companies/${companyId}/ovp/generate-forms`, { selectedUsers });

                        if (data) {
                            window.open(data, '_blank');
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: { error }
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_APPROVE_OVP_JOB_CONDITIONS](
            store,
            { ovpJobConditions, companyId }
        ) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                       
                        const url = `/api/companies/${companyId}/ovp/approve`;
                
                        const {
                            data: { success }
                        } = await axios.post(url, { ovpJobConditions });

                        if (success) {
                            return resolve();
                        }
                    } catch ({
                        response: {
                            data: { error }
                        }
                    }) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
    },
    getters: {
        [storeTypes.GET_OVP_JOB_CONDITIONS]: state => state.ovpJobConditions,
        [storeTypes.GET_GLOBAL_OVP_JOB_CONDITIONS]: state =>
            state.globalOvpJobConditions,
        [storeTypes.GET_CURRENT_OVP_JOB_CONDITION]: state =>
            state.currentOvpJobCondition,
        [storeTypes.GET_IS_LOADING]: state => state.isLoading,
        [storeTypes.GET_IS_ACTIVE_REQUEST]: state => state.isActiveRequest,
        [storeTypes.GET_SELECTED_OVP_USERS]: state => state.selectedUsers,
    }
};
